import * as React from 'react';

import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';
import { Link, Outlet, useParams } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout';
import Tab from 'src/components/navigation/Tab';
import TabRow from 'src/components/navigation/TabRow';
import { RESERVATION_TYPE } from 'src/features/reservations/types/reservationType';
import { reservationMessages } from 'src/features/reservations/utils/messages';
import { Button } from 'src/registry/ui/Button';
import { useTitleStore } from 'src/stores/useTitleStore';

const SelectedReservationTypeLayout = () => {
    const { parkingId } = useParams();
    const { reservationType } = useParams();
    const { formatMessage } = useIntl();
    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        if (!reservationType) return;
        setTitle(formatMessage(reservationMessages[reservationType as RESERVATION_TYPE]));
        return () => removeTitle();
    }, [reservationType, formatMessage]);

    return (
        <>
            <TabRow>
                <Tab end to={`/parking-management/${parkingId}/reservations/dynamic/${reservationType}`}>
                    {formatMessage(reservationMessages.details)}
                </Tab>
                <Tab to={`/parking-management/${parkingId}/reservations/dynamic/${reservationType}/versions`}>
                    {formatMessage(reservationMessages.versions)}
                </Tab>
            </TabRow>

            <Button asChild className="-mt-6 place-self-start p-0" variant="link">
                <Link to={`/parking-management/${parkingId}/reservations/dynamic`}>
                    <FontAwesomeIcon icon={faChevronLeft} className="opacity-50" />
                    {formatMessage(reservationMessages.backReservations)}
                </Link>
            </Button>
            <MainLayout>
                <Outlet />
            </MainLayout>
        </>
    );
};

export default SelectedReservationTypeLayout;
